/* =====================================================================
   HYDRATION + ENERGY - bespoke PDP behaviour
   Vanilla port of the approved React design. No dependencies.
   Owns: state (mode/flavour/qty), chapter nav, sticky bars, gallery,
   lightbox, accordions, calculator, fuel timeline, UGC rail, vibes,
   curve draw, real cart add.
   ===================================================================== */
(function () {
  'use strict';

  // Every HE section injects this same <script> tag, so on the full template it is
  // present ~17 times and the browser executes the IIFE once per tag. Without this
  // guard each run binds another set of event listeners; a single click then fires
  // the handler N times, and the accordion toggle cancels itself whenever the
  // section count is even (open→close→open… nets to closed) — i.e. "won't open".
  // Run the body exactly once per page.
  if (window.__hpeReskinInit) return;

  var root = document.querySelector('.hpe');
  if (!root) return;

  window.__hpeReskinInit = true;

  var cfg = (function () {
    try { return JSON.parse(document.getElementById('HpeConfig').textContent); }
    catch (e) { return {}; }
  })();

  var reducedMotion = !cfg.forceMotion && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* the page is now composed of multiple .hpe sections - spread the
     force-motion flag to every root so CSS motion guards see it */
  if (cfg.forceMotion) {
    document.querySelectorAll('.hpe').forEach(function (el) { el.classList.add('hpe-force-motion'); });
  }

  var state = {
    mode: cfg.hasSubscription ? 'sub' : 'otp',
    qty: 1,
    flavour: cfg.flavour || 'Mixed Berry'
  };

  /* Require an explicit delivery-frequency choice before subscribing (prevents accidental subs) */
  if (cfg.hasSubscription) cfg.sellingPlanId = null;

  var money = function (pence) {
    return '£' + (pence / 100).toFixed(2);
  };
  var unitPrice = function () {
    return state.mode === 'sub' && cfg.subPrice ? cfg.subPrice : cfg.price;
  };

  /* ── price/qty rendering ─────────────────────────────────────────── */
  function renderState() {
    var total = unitPrice() * state.qty;
    document.querySelectorAll('[data-hpe-total]').forEach(function (el) { el.textContent = money(total); });
    document.querySelectorAll('[data-hpe-unit-price]').forEach(function (el) { el.textContent = money(unitPrice()); });
    document.querySelectorAll('[data-hpe-qty]').forEach(function (el) { el.textContent = state.qty; });
    document.querySelectorAll('[data-hpe-qty-label]').forEach(function (el) {
      el.textContent = state.qty + ' tub' + (state.qty > 1 ? 's' : '');
    });
    document.querySelectorAll('[data-hpe-mode-label]').forEach(function (el) {
      el.textContent = state.mode === 'sub' ? 'subscription' : 'one-time';
    });
    document.querySelectorAll('[data-hpe-klarna]').forEach(function (el) {
      el.textContent = money(Math.round(unitPrice() / 3));
    });
    document.querySelectorAll('[data-hpe-flavour]').forEach(function (el) { el.textContent = state.flavour; });
    document.querySelectorAll('[data-hpe-perserving]').forEach(function (el) {
      el.textContent = '£' + (unitPrice() / 100 / 60).toFixed(2) + ' per serving';
    });
    document.querySelectorAll('[data-hpe-mode-card]').forEach(function (card) {
      card.classList.toggle('is-active', card.getAttribute('data-hpe-mode-card') === state.mode);
    });
    var needsFreq = cfg.hasSubscription && state.mode === 'sub' && !cfg.sellingPlanId;
    document.querySelectorAll('[data-hpe-atc-label]').forEach(function (el) {
      el.textContent = needsFreq ? 'Select a delivery frequency' : (state.mode === 'sub' ? 'Subscribe & Add to Cart' : 'Add to Cart');
    });
    document.querySelectorAll('[data-hpe-atc] [data-hpe-total]').forEach(function (el) { el.style.display = needsFreq ? 'none' : ''; });
  }

  /* purchase mode cards */
  document.querySelectorAll('[data-hpe-mode-card]').forEach(function (card) {
    card.addEventListener('click', function () {
      state.mode = card.getAttribute('data-hpe-mode-card');
      renderState();
    });
  });

  /* subscription frequency picker */
  var planSel = document.querySelector('[data-hpe-plan-select]');
  if (planSel) {
    planSel.addEventListener('change', function () {
      cfg.sellingPlanId = planSel.value ? parseInt(planSel.value, 10) : null;
      var opt = planSel.options[planSel.selectedIndex];
      var p = parseInt(opt.getAttribute('data-price'), 10);
      if (p) cfg.subPrice = p;
      state.mode = 'sub';
      renderState();
    });
    planSel.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  /* qty steppers */
  document.querySelectorAll('[data-hpe-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var d = parseInt(btn.getAttribute('data-hpe-qty-step'), 10);
      state.qty = Math.max(1, state.qty + d);
      renderState();
    });
  });

  /* flavour pills (buybox + flavour showcase) */
  function selectFlavour(name) {
    state.flavour = name;
    document.querySelectorAll('[data-hpe-flavour-pick]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-hpe-flavour-pick') === name);
    });
    renderState();
  }
  document.querySelectorAll('[data-hpe-flavour-pick]').forEach(function (el) {
    el.addEventListener('click', function () { selectFlavour(el.getAttribute('data-hpe-flavour-pick')); });
  });

  /* ── cart add ────────────────────────────────────────────────────── */
  var toastTimer = null;
  function showToast(html, tone) {
    var old = document.querySelector('.hpe-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'hpe-toast';
    t.innerHTML = (tone === 'err'
      ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f87171" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>'
      : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="' + (cfg.accent || '#FFFC00') + '" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>') + '<span>' + html + '</span>';
    document.body.appendChild(t);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.remove(); }, 3600);
  }

  function addToCart(btn) {
    if (!cfg.variantId) return;
    /* Require an explicit delivery frequency before a subscription can be added */
    if (cfg.hasSubscription && state.mode === 'sub' && !cfg.sellingPlanId) {
      var sel = document.querySelector('[data-hpe-plan-select]');
      if (sel) {
        var card = sel.closest('.bb-pcard') || sel;
        card.classList.add('hpe-freq-flash');
        setTimeout(function () { card.classList.remove('hpe-freq-flash'); }, 1400);
        try { sel.scrollIntoView({ behavior: 'smooth', block: 'center' }); sel.focus(); } catch (e) {}
      }
      showToast('Please choose how often you’d like it delivered.', 'err');
      return;
    }
    var item = { id: cfg.variantId, quantity: state.qty };
    if (state.mode === 'sub' && cfg.sellingPlanId) item.selling_plan = cfg.sellingPlanId;
    var prev = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      showToast('Added ' + state.qty + '× ' + (cfg.title || 'Hydration + Energy') + ' · ' + state.flavour + ' &nbsp;<a href="' + ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart">View cart →</a>');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function (err) {
      showToast(err.message || 'Could not add to cart', 'err');
    }).finally(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = prev; renderState(); }
    });
  }
  document.querySelectorAll('[data-hpe-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () { addToCart(btn); });
  });

  /* ── sticky bars (chapter nav + bottom bar) ──────────────────────── */
  var heroAtc = document.querySelector('[data-hpe-atc-anchor]');
  var cnav = document.querySelector('.hpe-cnav-wrap');
  var sbar = document.querySelector('.hpe-sbar');
  if (heroAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      var below = !entries[0].isIntersecting;
      if (cnav) cnav.classList.toggle('is-visible', out);
      if (sbar) sbar.classList.toggle('is-visible', below && out);
    }, { threshold: 0 }).observe(heroAtc);
  }

  /* chapter nav active link + jump */
  var chapters = Array.prototype.slice.call(document.querySelectorAll('[data-hpe-chapter]'));
  var cnLinks = document.querySelectorAll('.hpe .cn-link');
  cnLinks.forEach(function (l) {
    l.addEventListener('click', function () {
      var el = document.getElementById(l.getAttribute('data-target'));
      if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 116, behavior: 'smooth' });
    });
  });
  var navRaf = 0;
  function measureNav() {
    navRaf = 0;
    var cur = chapters.length ? chapters[0].id : null;
    chapters.forEach(function (c) { if (c.getBoundingClientRect().top < 180) cur = c.id; });
    cnLinks.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-target') === cur); });
  }
  if (chapters.length && cnLinks.length) {
    window.addEventListener('scroll', function () { if (!navRaf) navRaf = requestAnimationFrame(measureNav); }, { passive: true });
    measureNav();
  }

  /* ── gallery + lightbox ──────────────────────────────────────────── */
  var galMainImg = document.querySelector('[data-hpe-gal-main]');
  var galThumbs = Array.prototype.slice.call(document.querySelectorAll('[data-hpe-gal-thumb]'));
  var galIndex = 0;
  function setGal(i) {
    galIndex = (i + galThumbs.length) % galThumbs.length;
    var t = galThumbs[galIndex];
    if (galMainImg && t) {
      galMainImg.src = t.getAttribute('data-src');
      galMainImg.alt = t.getAttribute('data-alt') || '';
    }
    galThumbs.forEach(function (th, j) { th.classList.toggle('is-active', j === galIndex); });
    var lbImg = document.querySelector('.hpe-lb .lb-stage img');
    if (lbImg) lbImg.src = t.getAttribute('data-src');
    document.querySelectorAll('.hpe-lb .lb-dot').forEach(function (d, j) { d.classList.toggle('is-active', j === galIndex); });
  }
  galThumbs.forEach(function (t, i) { t.addEventListener('click', function () { setGal(i); }); });

  var lb = document.querySelector('.hpe-lb');
  if (lb) {
    var openLb = function () { lb.classList.add('is-open'); };
    var closeLb = function () { lb.classList.remove('is-open'); };
    var galMain = document.querySelector('.gal-main');
    if (galMain) galMain.addEventListener('click', openLb);
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    var c = lb.querySelector('.lb-close'); if (c) c.addEventListener('click', closeLb);
    var p = lb.querySelector('.lb-prev'); if (p) p.addEventListener('click', function (e) { e.stopPropagation(); setGal(galIndex - 1); });
    var n = lb.querySelector('.lb-next'); if (n) n.addEventListener('click', function (e) { e.stopPropagation(); setGal(galIndex + 1); });
    lb.querySelectorAll('.lb-dot').forEach(function (d, i) { d.addEventListener('click', function (e) { e.stopPropagation(); setGal(i); }); });
    window.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowRight') setGal(galIndex + 1);
      if (e.key === 'ArrowLeft') setGal(galIndex - 1);
    });
  }

  /* ── accordions (buybox + dossier) ───────────────────────────────── */
  document.querySelectorAll('[data-hpe-acc]').forEach(function (group) {
    group.querySelectorAll('[data-hpe-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-hpe-acc-item]');
        var wasOpen = item.classList.contains('is-open');
        group.querySelectorAll('[data-hpe-acc-item]').forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
        group.querySelectorAll('[data-hpe-acc-btn] .bba-toggle, [data-hpe-acc-btn] .dt-acctoggle').forEach(function (t) {
          t.textContent = t.closest('[data-hpe-acc-item]').classList.contains('is-open') ? '−' : '+';
        });
      });
    });
  });

  /* ── serving calculator ──────────────────────────────────────────── */
  var calc = document.querySelector('[data-hpe-calc]');
  if (calc) {
    var ZONES = [
      { c: cfg.accent || '#FFFC00', dark: true, t: 'Light, clean lift' },
      { c: '#FF9F1C', dark: true, t: 'Moderate: solid focus' },
      { c: '#F4602A', dark: false, t: 'High: ease off late in the day' },
      { c: '#E02424', dark: false, t: 'Daily max: don’t exceed' }
    ];
    var zone = function (s) { return ZONES[Math.max(1, Math.min(4, s)) - 1]; };
    var cs = { kg: 75, hrs: 1.5, intensity: 'Moderate', pick: null };
    var kgEl = calc.querySelector('[data-calc-kg]');
    var hrsEl = calc.querySelector('[data-calc-hrs]');

    function renderCalc() {
      var factor = { Easy: 0.4, Moderate: 0.8, Hard: 1.2 }[cs.intensity];
      var sweat = Math.round(cs.kg * 8 * factor * cs.hrs);
      var rec = Math.max(1, Math.min(4, Math.round(sweat / 500)));
      var servings = cs.pick == null ? rec : cs.pick;
      var z = zone(servings);
      calc.querySelector('[data-calc-kg-val]').textContent = cs.kg + 'kg';
      calc.querySelector('[data-calc-hrs-val]').textContent = cs.hrs + 'h';
      calc.querySelector('[data-calc-head]').textContent = cs.pick == null ? 'Recommended per session' : 'Your selection';
      calc.querySelector('[data-calc-servings]').textContent = servings;
      calc.querySelector('[data-calc-unit]').textContent = 'serving' + (servings > 1 ? 's' : '');
      calc.querySelector('[data-calc-fluid]').textContent = (500 * servings) + 'ml';
      calc.querySelector('[data-calc-caff]').textContent = (servings * 100) + 'mg';
      calc.querySelector('[data-calc-sweat]').textContent = '~' + sweat + 'ml';
      calc.querySelector('[data-calc-caffbolt]').style.color = z.c;
      calc.querySelectorAll('[data-calc-chip]').forEach(function (chip) {
        var nn = parseInt(chip.getAttribute('data-calc-chip'), 10);
        var on = servings === nn, zz = zone(nn);
        chip.style.background = on ? zz.c : 'rgba(255,255,255,.05)';
        chip.style.color = on ? (zz.dark ? '#111' : '#fff') : 'rgba(255,255,255,.7)';
        chip.style.borderColor = on ? zz.c : 'rgba(255,255,255,.14)';
      });
      calc.querySelectorAll('[data-calc-meterseg]').forEach(function (seg) {
        var nn = parseInt(seg.getAttribute('data-calc-meterseg'), 10);
        seg.style.background = nn <= servings ? zone(nn).c : 'rgba(255,255,255,.08)';
      });
      var zl = calc.querySelector('[data-calc-zone]');
      zl.querySelector('.ca-zonedot').style.background = z.c;
      var zAmt = zl.querySelector('[data-calc-zone-amt]');
      zAmt.textContent = (servings * 100) + 'mg';
      zAmt.style.color = z.c;
      zl.querySelector('[data-calc-zone-t]').textContent = '· ' + z.t;
      calc.querySelectorAll('[data-calc-int]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-calc-int') === cs.intensity);
      });
    }
    if (kgEl) kgEl.addEventListener('input', function () { cs.kg = +kgEl.value; cs.pick = null; renderCalc(); });
    if (hrsEl) hrsEl.addEventListener('input', function () { cs.hrs = +hrsEl.value; cs.pick = null; renderCalc(); });
    calc.querySelectorAll('[data-calc-int]').forEach(function (b) {
      b.addEventListener('click', function () { cs.intensity = b.getAttribute('data-calc-int'); cs.pick = null; renderCalc(); });
    });
    calc.querySelectorAll('[data-calc-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () { cs.pick = parseInt(chip.getAttribute('data-calc-chip'), 10); renderCalc(); });
    });
    renderCalc();
  }

  /* ── fuel-better scroll timeline ─────────────────────────────────── */
  var fuel = document.querySelector('[data-hpe-fuel]');
  if (fuel) {
    var rows = fuel.querySelectorAll('.fb-row');
    var fill = fuel.querySelector('.fb-trackfill');
    var fuelRaf = 0;
    var measureFuel = function () {
      fuelRaf = 0;
      var mid = window.innerHeight * 0.45;
      var idx = 0;
      rows.forEach(function (el, i) { if (el.getBoundingClientRect().top < mid) idx = i; });
      rows.forEach(function (el, i) {
        el.classList.toggle('is-active', i === idx);
        el.classList.toggle('is-done', i < idx);
      });
      var dot = rows[idx] && rows[idx].querySelector('.fb-dot');
      if (dot && fill) {
        var wTop = fuel.getBoundingClientRect().top;
        var d = dot.getBoundingClientRect();
        fill.style.height = Math.max(0, d.top + d.height / 2 - wTop) + 'px';
      }
    };
    window.addEventListener('scroll', function () { if (!fuelRaf) fuelRaf = requestAnimationFrame(measureFuel); }, { passive: true });
    window.addEventListener('resize', measureFuel);
    measureFuel();
    setTimeout(measureFuel, 300);
  }

  /* ── UGC rail arrows ─────────────────────────────────────────────── */
  var ugScroller = document.querySelector('.ef-ugc-scroll');
  if (ugScroller) {
    // Manual rAF tween - native smooth-scroll is unreliable on iOS / snap containers
    var ugTween = null;
    function ugScrollTo(target) {
      if (ugTween) cancelAnimationFrame(ugTween);
      var max = ugScroller.scrollWidth - ugScroller.clientWidth;
      target = Math.max(0, Math.min(max, target));
      var startL = ugScroller.scrollLeft;
      var dist = target - startL;
      var t0 = null, dur = 420;
      if (Math.abs(dist) < 2) { ugScroller.scrollLeft = target; return; }
      // Disable scroll-snap during the tween - proximity snap reverts incremental writes
      ugScroller.style.scrollSnapType = 'none';
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
        ugScroller.scrollLeft = startL + dist * e;
        if (p < 1) { ugTween = requestAnimationFrame(tick); }
        else { ugScroller.style.scrollSnapType = ''; }
      }
      ugTween = requestAnimationFrame(tick);
    }
    document.querySelectorAll('[data-hpe-ugc-arrow]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-hpe-ugc-arrow'), 10);
        var step = ugScroller.querySelector('.ug-slide');
        var w = step ? step.getBoundingClientRect().width + 16 : 300;
        ugScrollTo(ugScroller.scrollLeft + dir * w * 2);
      });
    });

    /* UGC video tiles: lazy-load + autoplay (muted, looped) only while a tile is
       scrolled into the rail's view; pause when it leaves. Keeps bandwidth/CPU low. */
    var ugVideos = ugScroller.querySelectorAll('[data-hpe-ugc-video]');
    if (ugVideos.length && 'IntersectionObserver' in window) {
      var ugVidIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            if (!v.getAttribute('src') && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
            v.muted = true;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { root: ugScroller, threshold: 0.5 });
      ugVideos.forEach(function (v) { ugVidIO.observe(v); });
    }
  }

  /* ── energy curve draw-in ────────────────────────────────────────── */
  var curve = document.querySelector('.ef-energy-curve');
  if (curve) {
    var drawCurve = function () { curve.classList.add('ef-drawn'); };
    if (reducedMotion) {
      drawCurve();
    } else if ('IntersectionObserver' in window) {
      // Observe the chart container (observing an SVG <path> is unreliable on iOS)
      var chartHost = curve.closest('.eb-chart') || curve;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { drawCurve(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(chartHost);
      // Safety net: never leave the curve invisible if the observer doesn't fire
      setTimeout(function () { if (!curve.classList.contains('ef-drawn')) drawCurve(); }, 2500);
    } else { drawCurve(); }
  }

  /* ── ambient vibes fields (deterministic) ────────────────────────── */
  function rng(seed) { var s = seed * 9301 + 49297; return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
  function fillVibes(host) {
    var type = host.getAttribute('data-hpe-vibes');
    var seed = parseInt(host.getAttribute('data-seed') || '7', 10);
    var r = rng(seed), html = '', i;
    if (type === 'energy') {
      for (i = 0; i < 16; i++) {
        var dur = 5 + r() * 6, left = r() * 100, h = 10 + r() * 16, sx = (r() * 36 - 18);
        html += '<span class="ef-spark" style="left:' + left + '%;height:' + h + 'px;animation-duration:' + dur + 's;animation-delay:' + (-r() * dur) + 's;--sx:' + sx + 'px"></span>';
      }
      for (i = 0; i < 4; i++) {
        var bd = 9 + r() * 7, bl = 8 + r() * 84, bs = 12 + r() * 10;
        html += '<svg class="ef-bolt" width="' + bs + '" height="' + (bs * 1.5) + '" viewBox="0 0 24 36" fill="currentColor" style="left:' + bl + '%;animation-duration:' + bd + 's;animation-delay:' + (-r() * bd) + 's"><path d="M14 0 2 20h7l-3 16 16-22h-8l5-14z"/></svg>';
      }
    } else if (type === 'beads') {
      for (i = 0; i < 16; i++) {
        var size = 4 + r() * 12, d2 = 3 + r() * 4;
        html += '<span class="ef-bead" style="left:' + (r() * 100) + '%;top:' + (r() * 100) + '%;width:' + size + 'px;height:' + size + 'px;animation-duration:' + d2 + 's;animation-delay:' + (-r() * d2) + 's"></span>';
      }
    } else if (type === 'sparks') {
      for (i = 0; i < 10; i++) {
        html += '<span class="ef-spark" style="left:' + (6 + i * 9) + '%;--sx:' + ((i % 2 ? -1 : 1) * 14) + 'px;animation-duration:' + (5 + i % 4) + 's;animation-delay:' + (i * 0.5) + 's;height:' + (12 + (i % 3) * 4) + 'px"></span>';
      }
    }
    host.innerHTML = html;
  }
  if (!reducedMotion) {
    document.querySelectorAll('[data-hpe-vibes]').forEach(fillVibes);
  }

  /* ── workout video play ──────────────────────────────────────────── */
  var wv = document.querySelector('[data-hpe-video]');
  if (wv) {
    var playBtn = wv.querySelector('.wv-play');
    var vidUrl = wv.getAttribute('data-video-url');
    if (playBtn && vidUrl) {
      playBtn.addEventListener('click', function () {
        var v = document.createElement('video');
        v.src = vidUrl; v.controls = true; v.autoplay = true; v.playsInline = true;
        wv.innerHTML = ''; wv.appendChild(v);
      });
    } else if (playBtn) { playBtn.style.display = 'none'; }
  }

  renderState();
})();
